import React from "react";
import { Text } from "../../components/Text";
import { CareerData } from "../career.data";
import { TimelineEntry } from "./timeline-entry";
import { getColumnForMonth, getColumnsForYears, getMonthList } from "./helper";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

interface TimelineListProps {
  entries: CareerData[];
  onSelect: (id: string) => void;
  selectedId: string;
}

export default function TimelineList({
  entries,
  selectedId,
  onSelect,
}: TimelineListProps) {
  const months = getMonthList(entries);
  const years = getColumnsForYears(entries);
  const { t } = useTranslation();
  return (
    <div className="grid gap-y-4 overflow-x-scroll snap-x snap-mandatory grid-cols-[repeat(var(--months),40px)] grid-rows-[repeat(4,40px)_[months]_auto_[years]_auto_8px]"
      style={{ '--months': months.length } as React.CSSProperties}>
      {months.map((month, i) => (
        <React.Fragment key={i}>
          <div
            className={clsx({
              'bg-steel-200': i % 2 === 0,
            })}
            style={{ gridRow: "1 / 6", gridColumnStart: i + 1 }}
          />
          <div
            className={clsx({
              'border-y-0 border-l-0 border-r border-solid border-gray-500': month.get("month") === 0,
            })}
            style={{ gridRow: "1 / 8", gridColumnStart: i + 1 }}
          />
          <div
            className="text-center whitespace-nowrap"
            style={{ gridColumn: i + 1, gridRow: "months" }}
          >
            <Text variant="caption">
              {t("generic_date", {
                date: month.toDate(),
                formatParams: { date: { month: "short" } },
              })}
            </Text>
          </div>
        </React.Fragment>
      ))}
      {years.map((year) => (
        <div
          key={year.year}
          className="flex justify-center"
          style={{
            gridRow: "years",
            gridColumn: `${year.start} / ${year.end}`,
          }}
        >
          <Text variant="caption">{year.year}</Text>
        </div>
      ))}
      {entries.map((entry, i) => (
        <TimelineEntry
          key={entry.id}
          isActive={entry.id === selectedId}
          entry={entry}
          row={entry.row}
          gridColumnStart={getColumnForMonth(entry.endDate)}
          gridColumnEnd={getColumnForMonth(entry.startDate) + 1}
          onClick={() => onSelect(entry.id)}
        />
      ))}
    </div>
  );
}
